import {IHttpService, ILogService, IPromise} from "angular";
import * as _ from "lodash";
import * as angular from "angular";

export class CourseService {

    /* @ngInject */
    constructor(private $http: IHttpService, private $log: ILogService) {
        $log.info("CourseService#");
    }

    public getCurrentCourses(studentId): any {
        this.$log.debug("CourseService#getCurrentCourses %o", studentId);
        return this.$http.get("/api/current-courses", {params: {studentId: studentId}}).then((resp) => {
            if (resp.data != null) {
                _.forEach(resp.data, (c) => {
                    if (c.course === undefined) {
                        c.course = angular.copy(c, c.course);
                    }
                    c.courseCode = c.code;
                    if (c.campuses != null && c.campuses.length === 1) {
                        c.campus = c.campuses[0].code;
                    }
                });
            }
            this.$log.debug("getCurrentCourses %o", resp.data);
            return resp.data;
        }).catch((reason) => {
            // TODO: remove this catch block when the student id can be guaranteed true.
            this.$log.debug("getCurrentCourses error %o", reason);
            return [];
        });
    }

    public getRemoteCourses(query, year): any {
        this.$log.debug("CourseService#getRemoteCourses %o %o", query, year);
        return this.$http.get("/api/search/courses", {params: {query: query, year: year}}).then((resp) => {
            this.$log.debug("getCourses %o", resp.data);
            return resp.data;
        });
    }

    public getBlockedCourses(courseCode): IPromise<any> {
        this.$log.debug("CourseService#getBlockedCourses %o %o", courseCode);
        return this.$http.get("/api/search/blocked-courses", {params: {courseCode: courseCode}}).then((resp) => {
            this.$log.debug("getBlockedCourses %o", resp.data);
            return resp.data;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/course/course.service.ts